<div class="sub-component-container" *ngIf="subRemarksToSupplier">
  <div class="sub-title">{{'sub-remarks-to-supplier-title' | translate}}</div>
  <div class="sub-content-container">
    <div class="row">
      <div class="col-12">
        <app-text-box [disabled]="readOnlyMode" [name]="'sub-remarks-to-supplier' | translate" [maxTextLength]="1000"
                      [(value)]="subRemarksToSupplier.remarks"></app-text-box>
      </div>
    </div>
  </div>
</div>
